import { NavListContext, NavShowContext, ScreenTopContext, TestStateContext } from 'App';
import { Button, Grid, SearchBar, Switch, Toast } from 'antd-mobile';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { useWindowSize } from 'usehooks-ts';
import styles from './index.module.scss';
import { isEmpty } from 'utils/listUtil';
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import TermList from 'components/dot/term-list';
import TermPostList from 'components/dot/term-post-list';
import FilterBar from 'components/dot/filter-bar';
import ResourceValidator from 'components/dot/resource-validator';

export type NavDT = {
  btmTermList: TermsNodeListDT[];
  top1TermList: TermsNodeListDT[];
  top2TermList: TermsNodeListDT[];
  btmTermNow: TermsNodeListDT;
  top1TermNow: TermsNodeListDT;
  top2TermNow: TermsNodeListDT;
};

const Home = () => {
  const screenTop = useContext(ScreenTopContext);
  const navList = useContext(NavListContext).navList;
  const updateNavList = useContext(NavListContext).updateNavList;
  const testState = useContext(TestStateContext).testState;
  const updateTestState = useContext(TestStateContext).updateTestState;
  const navShowState = useContext(NavShowContext).navShowState;
  const updateNavShowState = useContext(NavShowContext).updateNavShowState;
  const navigate = useNavigate();
  const [searchAllCategory, toggleSearchAllCategory] = useState(false);
  const [sortType, toggleType] = useState('latest'); // latest, trend, hotest
  const [expandSortType, toggleExpandSortType] = useState(true); // 是否展开排序按钮

  useEffect(() => {
    // 修改导航
    updateNavShowState((draft) => {
      draft.showBottomNav = true;
      draft.showTop1Nav = true;
      draft.showTop2Nav = true;
      draft.showTitleNav = false;
    });
  }, []);

  return (
    <>
      <center className=" relative">
        {/* 资源检测 */}
        {false && <ResourceValidator />}
        {/* 搜索 + 排序 */}
        <div className=" sticky top-10 z-10 ">
          <FilterBar
            updateSortType={(sortType: string) => {
              toggleType(sortType);
            }}
          />
        </div>
        <div className=" sticky top-24 z-0">
          {/* 标签区域 */}
          <TermList termTaxonomy="tag" />
          {/* 专题区域 */}
          <TermList termTaxonomy="topics" />
        </div>
        {/* 内容区域 */}
        <div className=" mt-1">
          {/* 图片列表 */}
          <TermPostList
            showTermNamePrefix={true}
            termTaxonomy="category"
            termId={null}
            sortType={sortType}
            changeIndexEnabled={true}
          />
        </div>
      </center>
    </>
  );
};

export default Home;
